export { default } from "./DeleteRole";



// WEBPACK FOOTER //
// ./src/mutations/DeleteRole/index.ts